const KEY = 'prospector_admin_key';

export function getAdminKey(): string | null {
  return sessionStorage.getItem(KEY);
}

export function setAdminKey(key: string) {
  sessionStorage.setItem(KEY, key);
}

export function clearAdminKey() {
  sessionStorage.removeItem(KEY);
}

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function api<T = unknown>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const key = getAdminKey();
  const headers = new Headers(init.headers || {});
  if (key) headers.set('Authorization', `Bearer ${key}`);
  if (init.body && !headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }
  const res = await fetch(path, { ...init, headers });
  const ctype = res.headers.get('content-type') || '';
  if (ctype.includes('text/csv')) {
    if (!res.ok) throw new ApiError(`Export failed (${res.status})`, res.status);
    return (await res.blob()) as T;
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg =
      (data as { error?: string }).error || `Request failed (${res.status})`;
    throw new ApiError(msg, res.status);
  }
  return data as T;
}
